import MainRoutes from './routes'
export default MainRoutes
